Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
  { date: "10", views: 25, text: "China" },
  { date: "11", views: 30, text: "India" },
  { date: "12", views: 22, text: "Indonesia" },
  { date: "13", views: 30, text: "US" },
  { date: "14", views: 43, text: "Brazil" },
  { date: "15", views: 40, text: "Germany" },
  { date: "16", views: 33, text: "Egypt" },
];
